import {
	apis,
	callApi
} from 'webasercomps/src/apis';

import * as device from './device/index';

const allApis = Object.assign({}, apis, {
	[device.eps.FETCH_DEVICES]: device.fetch,
	[device.eps.CREATE_DEVICE]: device.create,
	[device.eps.MODIFY_DEVICE]: device.modify
});

export const api = callApi(allApis);

const eps = {
	...device.eps
}

export {
	eps
}